import {useQuery} from '@tanstack/react-query';
import {fetchRest} from '../helpers/fetchRest';
import utils from '../helpers/utils';
import {TXM_DEFAULT_LOOK_BACK} from '../constants/durations';
import dateUtils from '../helpers/dateUtils';

/**
 * get user transactions unified
 * @param {string} accountId - user account id to get transactions
 * @param {ProductFeatures} productFeatures - ProductFeatures
 * @param {boolean} hasInstitutions - boolean to determine if the user has institutions
 * @return {Object} returns users transactions, success and error fields
 */
const useTransactionsUnified = (accountId: string, productFeatures: ProductFeatures, hasInstitutions: boolean) => {
  const transactionArgs = {
    startDate: new Date(dateUtils.getStartDate(TXM_DEFAULT_LOOK_BACK)).toISOString(),
    endDate: new Date().toISOString(),
    sortBy: 'transactionDate',
    sortOrder: 'desc',
    count: '30',
  };

  const queryParam = new URLSearchParams(transactionArgs).toString();
  const url = utils.getTransactionsUnifiedPath(queryParam);
  const query = useQuery({
    queryKey: ['transactionsUnified', accountId],
    queryFn: () =>
      fetchRest(url, {
        method: 'GET',
        headers: {Accept: 'application/json', account_id: accountId},
      }),
    enabled: !!accountId && utils.isFeaturePresent(productFeatures, 'financialWellness') && hasInstitutions,
  });
  return {...query, isLoading: query.isPending};
};

export default useTransactionsUnified;
